/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-use-before-define */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Geosuggest from 'react-geosuggest';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import EditButton from '../../v2/buttons/EditButton';

const datepickerDefaultOptions = {
  showTimeSelect: false,
  dateFormat: 'L',
  isClearable: true,
  timeIntervals: 30,
  timeCaption: 'Time',
};
class ItemAlt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      value: this.props.value,
      name: this.props.name,
      hover: false,
    };
  }

  getEditComponent() {
    let component;
    let renderMenuItems;
    let titleFunction;
    const datepickerOptions = {
      ...datepickerDefaultOptions,
      ...this.props.datepickerOptions,
    };

    const {
      showTimeSelect,
      dateFormat,
      isClearable,
      timeIntervals,
      timeCaption,
    } = datepickerOptions;
    const { localizationKey, t, disableTitleize = false } = this.props;
    switch (this.props.type) {
      case 'date':
        component = (
          <DatePicker
            selected={mapDateValue(this.state.value)}
            placeholderText={this.props.placeholderText}
            className="w-full form-field"
            onChange={(val) => {
              const dateString = val ? val.toISOString() : null;
              this.handleValueChange(dateString);
            }}
            autoFocus
            showTimeSelect={showTimeSelect}
            dateFormat={dateFormat}
            isClearable={isClearable}
            timeIntervals={timeIntervals}
            timeCaption={timeCaption}
          />
        );
        break;
      case 'address':
        component = (
          <Geosuggest
            placeholder={t('SEARCH_PLACES')}
            inputClassName={this.props.inputClass || 'form-field'}
            initialValue={this.props.value}
            onSuggestSelect={(item) => {
              this.handleValueChange(item.gmaps.formatted_address);
            }}
          />
        );
        break;
      case 'currency':
        component = (
          <input
            type="number"
            min="0"
            step="0.10"
            className={this.props.inputClass || 'form-field'}
            value={this.state.value || ''}
            onChange={(e) => this.handleValueChange(e.target.value)}
          />
        );
        break;
      case 'dropdown':
        titleFunction = (strValue) =>
          disableTitleize ? t(strValue) : titleize(t(strValue));

        renderMenuItems = this.props.menuItems.map((serviceType) => (
          <option key={serviceType.value} value={serviceType.value}>
            {localizationKey &&
            localizationKey?.length &&
            Object.keys(serviceType).includes(localizationKey)
              ? titleFunction(serviceType[localizationKey])
              : serviceType.name}
          </option>
        ));
        component = (
          <fieldset className="">
            <select
              onChange={(e) => this.handleValueChange(e.target.value)}
              defaultValue={this.state.value}
              className="form-select"
            >
              {renderMenuItems}
            </select>
          </fieldset>
        );
        break;
      case 'dropdown_with_input':
        renderMenuItems = this.props.menuItems.map((serviceType) => (
          <option key={serviceType.value} value={serviceType.value}>
            {localizationKey &&
            localizationKey?.length &&
            Object.keys(serviceType).includes(localizationKey)
              ? titleize(t(serviceType[localizationKey]))
              : serviceType.name}
          </option>
        ));
        component = (
          <fieldset className="">
            <select
              onChange={(e) => this.handleValueChange(e.target.value)}
              defaultValue={this.state.value || this.props.displayValue}
              className="form-select"
            >
              {renderMenuItems}
            </select>
            {this.props.renderConditionalField &&
              this.state.value === 'Custom' && (
                <input
                  type="text"
                  className={this.props.inputClass || 'form-field'}
                  style={{ marginTop: 5, marginBottom: 5 }}
                  value={this.state.custom_value}
                  placeholder={this.props.inputPlaceholder || ''}
                  onChange={(e) =>
                    this.handleValueChange(e.target.value, 'custom_value')
                  }
                />
              )}
          </fieldset>
        );
        break;
      case 'number':
        component = (
          <input
            type="number"
            className={this.props.inputClass || 'form-field'}
            value={this.state.value || ''}
            onChange={(e) => this.handleValueChange(e.target.value)}
          />
        );
        break;
      default:
        // NOTE: Some components are passing in explicit types that fall into this default. See the Order Details component for examples. Type="string"
        component = (
          <input
            type="text"
            className={this.props.inputClass || 'form-field'}
            value={this.state.value || ''}
            onChange={(e) => this.handleValueChange(e.target.value)}
            maxLength={this.props.maxLength}
          />
        );
    }

    return component;
  }

  getDisplayComponent() {
    return (
      <div
        className={
          this.props.displayClass || 'text-gray-500 text-gray-900 texxt-sm'
        }
        data-testid="item-alt-value"
      >
        {this.props.displayValue || this.props.value}
      </div>
    );
  }

  getEditActions() {
    const defaultButtonClass = 'button button-green';
    const { t } = this.props;
    return (
      <div
        className={
          this.props.buttonContainerClass ||
          'flex flex-wrap mt-1 mb-4 space-x-1'
        }
      >
        <button
          className={this.props.saveButtonClass || defaultButtonClass}
          onClick={() => this.handleValueSave()}
          disabled={this.props.type === 'date' && !this.state.value}
        >
          {titleize(t('SAVE'))}
        </button>
        <button
          className={
            this.props.cancelButtonClass ||
            this.props.defaultCancelClass ||
            'button button-secondary'
          }
          onClick={() => this.setState({ hover: false, editing: false })}
        >
          {titleize(t('CANCEL'))}
        </button>
      </div>
    );
  }

  getDisplayAction() {
    if (!this.state.hover) {
      return null;
    }
    return <EditButton onClick={this.handleAction} size="small" />;
  }

  handleHover(hovered) {
    if (this.props.editable) {
      this.setState({ hover: hovered });
    }
  }

  handleAction = () => {
    this.setState({ editing: true });
  };

  handleValueChange(value, key) {
    if (!key) {
      this.setState({ value });
    } else {
      this.setState({ [key]: value });
    }
  }

  clearValues() {
    this.setState({
      custom_value: '',
      value: '',
    });
  }
  handleValueSave() {
    this.setState({ hover: false, editing: false }, () => {
      if (this.state.custom_value) {
        this.props.onValueSave({ [this.state.name]: this.state.custom_value });
      } else {
        this.props.onValueSave({ [this.state.name]: this.state.value });
      }
      this.clearValues();
    });
  }

  render() {
    if (this.state.editing) {
      return (
        <div className={this.props.rowClass}>
          {this.getEditComponent()}
          {this.getEditActions()}
        </div>
      );
    }
    return (
      <div
        className={this.props.rowClass || 'flex items-center min-h-6 space-x-2'}
        onMouseEnter={() => this.handleHover(true)}
        onMouseLeave={() => this.handleHover(false)}
      >
        <div>{this.getDisplayComponent()}</div>
        <div>{this.getDisplayAction()}</div>
      </div>
    );
  }
}

ItemAlt.propTypes = {
  type: PropTypes.string,
  editable: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.any,
  placeholderText: PropTypes.string,
  buttonContainerClass: PropTypes.string,
  defaultCancelClass: PropTypes.string,
  displayClass: PropTypes.string,
  displayValue: PropTypes.any,
  glyphClass: PropTypes.string,
  inputClass: PropTypes.string,
  rowClass: PropTypes.string,
  menuItems: PropTypes.array,
  cancelButtonClass: PropTypes.string,
  saveButtonClass: PropTypes.string,
  onValueSave: PropTypes.func,
  maxLength: PropTypes.number,
  datepickerOptions: PropTypes.shape({
    showTimeSelect: PropTypes.bool,
    dateFormat: PropTypes.string,
    isClearable: PropTypes.bool,
  }),
  renderConditionalField: PropTypes.bool,
  localizationKey: PropTypes.string,
};

ItemAlt.defaultProps = {
  datepickerOptions: { ...datepickerDefaultOptions },
  renderConditionalField: true,
};

function mapDateValue(value) {
  if (!value) {
    return null;
  }

  if (value instanceof moment) {
    return value;
  }

  return moment(value);
}

export default withTranslation()(ItemAlt);
